// source: imports/search/search_profile.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) {
    return this;
  }
  if (typeof window !== 'undefined') {
    return window;
  }
  if (typeof global !== 'undefined') {
    return global;
  }
  if (typeof self !== 'undefined') {
    return self;
  }
  return Function('return this')();
}.call(null));

var imports_options_event_metadata_pb =
    require('../../imports/options/event_metadata_pb.js');
goog.object.extend(proto, imports_options_event_metadata_pb);
goog.exportSymbol('proto.com.chegg.rio.search.SearchProfile', null, global);
/**
 * @enum {number}
 */
proto.com.chegg.rio.search.SearchProfile = {
  UNKNOWN_SEARCHPROFILE: 0,
  DECKS_SRP: 1,
  FLASHCARDS_AUTO: 2,
  STUDY_INTENT_SRP: 3,
  STUDY_DUPE_SRP: 4,
  STUDY_DECKS_INTENT_SRP: 5,
  STUDY_FUSED_SRP: 6,
  STUDY_INTENT_NATIVE_SRP: 7,
  FEDERATED_SRP: 8,
  FEDERATED_INTENT_SRP: 9,
  TEXTBOOKS_SRP: 10,
  TBS_SRP: 11,
  TBS_BOOK_AUTO: 12,
  TBS_BOOKS_SRP: 13,
  TBS_PROBLEM_SRP: 14,
  QUESTIONS_AUTO: 15,
  QUESTIONS_SRP: 16,
  FEDERATED_SUGGESTER: 17,
  FLASHTOOLS_SRP: 18,
  TEXTBOOKS_AUTO: 19,
  FEDERATED_AUTO: 20,
  FEDERATED_REROUTE_AUTO: 21,
  FEDERATED_CHEGG_STUDY_AUTO: 22,
  LEARN_SRP: 23,
  LEARN_AUTO: 24,
  FLASHTOOLS_AUTO: 25,
  BIGEGG_SUGGEST: 26,
  BIGEGG_SRP: 27
};

goog.object.extend(exports, proto.com.chegg.rio.search);



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/rio-event-schema-web/dist/imports/search/search_profile_pb.js
// module id = 1456
// module chunks = 11